import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, onSnapshot } from 'firebase/firestore';

interface DocumentData {
    ingestionProcess: any;
    loading: boolean;
    error: string | null;
}

export const useFirestoreDocument = (docId: string | null) => {
    const [data, setData] = useState<DocumentData>({
        ingestionProcess: null,
        loading: false,
        error: null,
    });

    useEffect(() => {
        if (!docId) {
            setData(prev => ({ ...prev, loading: false }));
            return;
        }

        setData(prev => ({ ...prev, loading: true, error: null }));

        const unsubscribe = onSnapshot(doc(db, "ingestion_process", docId), (doc) => {
            setData(prev => ({
                ...prev,
                ingestionProcess: doc.data() || null,
                loading: false
            }));
        }, (err) => {
            console.error("Error fetching ingestion_process:", err);
            setData(prev => ({ ...prev, error: "Failed to load processing status", loading: false }));
        });

        return () => {
            unsubscribe();
        };
    }, [docId]);

    return data;
};
